import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { AufgabenFilterBar } from "./ui/AufgabenFilterBar";
import { AufgabenList } from "./ui/AufgabenList";
import { TaskActionMenu } from "./ui/TaskActionMenu";

export const AufgabenPage = () => {
  return (
    <PageLayout
      pageTitle="Aufgaben"
      headerChildren={<TaskActionMenu />}
    >
      <div className="flex w-full flex-col gap-4">
        <AufgabenFilterBar />
        <AufgabenList />
      </div>
    </PageLayout>
  );
};
